import {
  GraphQLNonNull,
  GraphQLID,
  GraphQLInputObjectType,
  GraphQLList,
  GraphQLString
} from 'graphql'
import {
  customMetadataFilter,
  CustomMetadataFilter
} from './application-filter-arg'

export interface ArchitectureAssociatedApplicationsFilterArg {
  readonly componentHashes: string[]
  readonly tags?: string[]
  readonly technologies?: string[]
  readonly languages?: string[]
  readonly servers?: string[]
  readonly environments?: string[]
  readonly customMetadata?: CustomMetadataFilter[]
}

const filterList = new GraphQLList(GraphQLString)

const ArchitectureComponentApplicationsFilterArgType =
  new GraphQLInputObjectType({
    name: 'ArchitectureAssociatedApplicationsFilterArg',
    description:
      'A collection of criteria categories and values to filter the associated applications by',
    fields: () => ({
      componentHashes: {
        description: 'Filters applications by architecture component hashes',
        type: filterList
      },
      tags: {
        description: 'Filters applications by tags',
        type: filterList
      },
      technologies: {
        description: 'Filters applications by technology name',
        type: filterList
      },
      languages: {
        description: 'Filters applications by language',
        type: filterList
      },
      servers: {
        description: 'Filters applications by server ID',
        type: filterList
      },
      environments: {
        description: 'Filters applications by server environment',
        type: filterList
      },
      customMetadata: {
        description: 'Filter by custom metadata fields',
        type: new GraphQLList(customMetadataFilter)
      }
    })
  })

export interface ArchitectureComponentApplicationsArgs {
  readonly organizationID: string
  readonly applicationID: string
  readonly filters?: ArchitectureAssociatedApplicationsFilterArg
}

export const architectureComponentApplicationsArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  applicationID: {
    description: 'The unique ID for the application being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  filters: {
    description: 'Options for filtering associated applications',
    type: ArchitectureComponentApplicationsFilterArgType
  }
}
